var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "Card",
        [
          _c(
            "Row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "Col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "Tabs",
                    { attrs: { value: "name1" } },
                    [
                      _c(
                        "TabPane",
                        { attrs: { label: "APP广告", name: "name1" } },
                        [_c("AppAd", { ref: "appAd" })],
                        1
                      ),
                      _c(
                        "TabPane",
                        { attrs: { label: "PC广告", name: "name2" } },
                        [_c("PcAd", { ref: "pcAd" })],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }